export const getTenantPlanId = (plan) =>
  Number(
    plan?.planId ||
      plan?.planid ||
      plan?.PlanId ||
      plan?.PlanID ||
      0
  );

export const getSubscriptionStartDate = (plan) => {
  const startStr =
    localStorage.getItem("subscriptionStartDate") ||
    localStorage.getItem("paidStartDate") ||
    localStorage.getItem("trialStartDate") ||
    plan?.creationDate ||
    plan?.CreationDate;

  if (!startStr) return null;

  const startDate = new Date(startStr);
  return Number.isNaN(startDate.getTime()) ? null : startDate;
};

export const getSubscriptionDurationDays = (plan) => {
  const storedDays = Number(localStorage.getItem("subscriptionDurationDays") || "0");
  if (storedDays > 0) return storedDays;

  const planType = `${plan?.planType || ""} ${plan?.engPlanType || ""}`.toLowerCase();
  if (planType.includes("week") || planType.includes("trial")) return 7;
  if (planType.includes("month")) return 30;

  return 30;
};

export const isPlanExpired = (plan) => {
  if (!plan) return false;

  const startDate = getSubscriptionStartDate(plan);
  if (!startDate) return false;

  const durationDays = getSubscriptionDurationDays(plan);
  const diffDays = Math.floor((Date.now() - startDate.getTime()) / (1000 * 60 * 60 * 24));

  return diffDays >= durationDays;
};

export const clearSubscriptionMarkers = () => {
  [
    "subscriptionStartDate",
    "paidStartDate",
    "trialStartDate",
    "subscriptionDurationDays",
    "selectedPlan",
    "selectedPlanId",
    "selectedPlanPrice",
    "selectedPlanType",
    "selectedEngPlanType",
    "selectedPlanDesc",
    "selectedPlanEngDesc",
  ].forEach((key) => localStorage.removeItem(key));
};

export const deleteTenantPlanIfExpired = async ({ baseUrl, tenantId, plan, token }) => {
  const planId = getTenantPlanId(plan);
  if (!tenantId || tenantId === -1 || !planId) return false;

  const res = await fetch(
    `${baseUrl}/Plans/DeleteTenantPlan?TenantId=${tenantId}&PlanId=${planId}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: token ? `Bearer ${token}` : "",
      },
    }
  );

  if (!res.ok && res.status !== 404) {
    const errorData = await res.json().catch(() => ({}));
    const message = errorData.message || errorData.Message || `HTTP ${res.status}`;
    throw new Error(message);
  }

  clearSubscriptionMarkers();
  return true;
};
